import { Modal } from '@mui/material';
import { styled } from '@mui/material/styles';
import { KModalImportMode } from './types.js';

var PREFIX = "KModalImport";
var classes = {
    content: "".concat(PREFIX, "-content")
};
var StyledKModalImport = styled(Modal, {
    shouldForwardProp: function (prop) { return prop !== "mode"; }
})(function (_a) {
    var _b, _c;
    var theme = _a.theme, mode = _a.mode;
    return (_b = {},
        _b["& .".concat(classes.content)] = (_c = {},
            _c[theme.breakpoints.down("md")] = {
                gridTemplateAreas: mode === KModalImportMode.Upload
                    ? "\n                \"actions actions actions\" \n                \"content content content\"\n              "
                    : "\n                \"kgrid actions actions\" \n                \"kgrid content content\"\n              ",
                gridTemplateColumns: mode === KModalImportMode.Indexing || KModalImportMode.Success
                    ? "1fr 1fr 1fr"
                    : "2fr 1fr 1fr"
            },
            _c),
        _b);
});

export { classes, StyledKModalImport as default };
//# sourceMappingURL=index.styled.js.map
